define('customersDetailBodyMailsView',[
  'module',
  'backbone',
  'underscore',
  'app',
  'tableView',
  'tableDatetimeFieldView',
  'mailsMailView'
], function (
    Module,
    Backbone,
    _,
    App,
    TableView,
    DatetimeFieldView,
    MailView
) {
  'use strict';

  Module.exports = TableView.extend({
    className: 'customers-detail-mails-view ' + TableView.prototype.className,
    pageSize: 20,
    pageMode: 'pagination',

    setFields: function() {
      var fields = [];

      fields.push({
        name: 'Date',
        label: _.i18n('common.date'),
        bind: 'sentDate',
        className: 'sentDate',
        view: DatetimeFieldView
      });

      fields.push({
        name: 'subject',
        label: _.i18n('common.subject'),
        bind: 'subject',
        className: 'subject'
      });

      fields.push({
        name: 'labels',
        label: _.i18n('common.label'),
        bind: 'labels',
        className: 'labels',
        formatter: function(value) {
          if (!value || !value.length) return '';
          // Map the array of label objects to their names and join with commas
          return _.map(value, function(label) {
            var col = label.textColor?label.textColor:'';
            var bgCol = label.backgroundColor?label.backgroundColor:'';
            return '<div class="label-view" style="background-color: '+bgCol+'; color: '+col+'">' + label.name + '</div>';
          }).join('');
        }
      });


      return fields;
    },

    fetch: function(first, pageSize) {
      var defer = $.Deferred();

      if(!first) first = 0;
      if(pageSize) this.pageSize = pageSize;

      if(this.options.customer && this.options.customer.id) {
        var customerSecId = this.options.customer.id;


        var params = {};
        params.page = Math.ceil(first/this.pageSize);
        params.size = this.pageSize;

        if (this.fetchRequest)
          this.fetchRequest.abort();

        this.fetchRequest = $.ajax({
          type: 'GET',
          url: App.request('mails:get-customer-all-mails-url', customerSecId, params),
          success: _.bind(function (items) {
            var models = [];
            _.each(items.content, _.bind(function (item) {
              var model = App.request('mails:model', item);
              models.push(model);
            }, this));
            defer.resolve(models, items.totalElements);
          }, this)
        });
      }
      return defer.promise();
    },

    onRowDoubleClick: function (view) {
      if(view.model.get('emailAddress'))
        MailView.prototype.open(view.model, view.model.get('emailAddress').secId);
    }
  });
});
